<template>
  <div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
      redirectUri: process.env.VUE_APP_COGNITO_CALLBACK_URI,
      authUrl: process.env.VUE_APP_COGNITO_AUTH_URL,
      scopes: process.env.VUE_APP_COGNITO_SCOPES
    };
  },
  mounted() {

    localStorage.removeItem('tokenExpirationTime');
    localStorage.removeItem('refresh_token');
    const authEndpoint = `${this.authUrl}/oauth2/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&scope=${this.scopes}`;
    window.location.href = authEndpoint;
  }
};
</script>